import { useCallback, useState } from 'react';
import { FiCheck, FiCopy } from 'react-icons/fi';

function CopyButton({ text, className = '', label = 'Copy' }) {
  const [copied, setCopied] = useState(false);

  const onCopy = useCallback(async () => {
    if (!text) {
      return;
    }
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  }, [text]);

  return (
    <button
      type="button"
      className={`stx-copy-btn ${className}`.trim()}
      onClick={onCopy}
      aria-label={copied ? 'Copied' : label}
      title={copied ? 'Copied' : label}
    >
      {copied ? <FiCheck aria-hidden /> : <FiCopy aria-hidden />}
    </button>
  );
}

export default CopyButton;
